import { takeLatest, call, put } from 'redux-saga/effects'
import updateApplication from 'api/administration/applications/Edit'
import { IEnrolModel } from 'models/enrol.model'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import { EnrolState } from 'enum'
import I18n from 'i18n'
import * as fromActions from '../../actions/enrols.action'

async function updateEnrol(data: IEnrolModel) {
  return await updateApplication(data)
}

export function* enrolAdminEditEffectSaga(action: any) {
  try {
    yield call(updateEnrol, action.payload)
    yield put(fromActions.Actions.enrolAdminListReload())
    SuccessToast(
      I18n.t(
        `administration.toastMessages.${
          action.payload.stateAdmin === EnrolState.Approved
            ? 'requestApproved'
            : 'requestDenied'
        }`
      )
    )
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* enrolAdminEditWatcherSaga() {
  yield takeLatest(fromActions.ENROL_ADMIN_EDIT, enrolAdminEditEffectSaga)
}
